export default "__VITE_ASSET__LUl_dqgL__"